module.exports = __webpack_public_path__ + "assets/images/rbyearend-02-desktop.jpg?v=08adce3e";